import { http, jsonToImmutable, jsonToImmutableError } from '@gonfalon/legacy-http-client/httpUtils';

import type { SdkVersionContextUsage } from '#components/SdkNotification/sdkNotificationUtils';
import { Logger } from '#utils/logUtils';

const logger = Logger.get('ContextUsageApi');

export async function getContextUsageSdks(projKey: string, envKey: string): Promise<SdkVersionContextUsage[]> {
  try {
    const raw = await http.get(`/internal/usage/sdk-versions/${projKey}/${envKey}`);
    const result = await jsonToImmutable(raw).catch(jsonToImmutableError);
    return result.toJS();
  } catch (e) {
    logger.error(`Error fetching getContextUsageSdks: ${JSON.stringify(e)}`);
    throw e;
  }
}
